/** Measure the rendered card pitch, including the real row gap/padding. */
export function productRailStep(element: HTMLElement): number {
  const children = Array.from(element.children) as HTMLElement[];
  const first = children[0]?.getBoundingClientRect();
  const second = children[1]?.getBoundingClientRect();
  if (first && second) {
    const pitch = Math.abs(second.left - first.left);
    if (pitch > 0) return pitch;
  }
  return first?.width || element.clientWidth;
}
export function scrollProductRail(element: HTMLElement | null, direction: -1 | 1): void {
  if (!element) return;
  element.scrollBy({
    left: direction * productRailStep(element),
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
  });
}
